import './index.scss';
import { observer } from 'mobx-react-lite';
import Table from 'react-bootstrap/Table';
import StatusIconGreen from '@assets/svg/user-status-icon-green.svg';
import StatusIconGrey from '@assets/svg/user-status-icon-grey.svg';
import StatusIconYellow from '@assets/svg/user-status-icon-yellow.svg';
import { formatDate } from '@utils/utils';
import { useNavigate } from 'react-router-dom'

const TaskHistoryList = observer(({ tasks }) => {
    let navigate = useNavigate();

    const getStatusIcon = (status) => {
        switch (status) {
            case 'closed':
                return StatusIconGrey;
            case 'in_progress':
                return StatusIconYellow;
            default:
                return StatusIconGreen;
        }
    }
    const getStatusText = (status) => {
        switch (status) {
            case 'new':
                return 'Yeni';
            case 'in_progress':
                return 'İşlədə';
            case 'submission':
                return 'Yoxlama üçün göndərildi';
            case 'done':
                return 'Tamamlandı';
            case 'closed':
                return 'Bağlandı';
            default:
                return 'Yeni';
        }
    }

    const goToTask = (id) => {
        navigate(`/tasks/${id}`, { replace: true });
    };

    return (
        <div className="task-history-list">
            <Table>
                <thead>
                    <tr className="border-bottom-white">
                        <th className="header-title">Ad</th>
                        <th className="header-title desktop-only">Yerləşdirilib</th>
                        <th className="header-title">Sifariş məbləği</th>
                        <th className="header-title desktop-only">Təhvil tarixi</th>
                        <th className="header-title">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {tasks && tasks.map((task, index) =>
                        <tr className="task" key={`task_${index}`} onClick={() => {goToTask(task.id)}}>
                            <td className="task-title">{task.title}</td>
                            <td className="task-created desktop-only">{formatDate(new Date(task.created))}</td>
                            <td className="task-price">{task.price > 0 ? task.price.toLocaleString('ru-RU') : ''} AZN</td>
                            <td className="task-deadline desktop-only">{task.deadline} saat</td>
                            <td className="task-status">
                                <img src={getStatusIcon(task.task_status)} />
                                {getStatusText(task.task_status)}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
})

export { TaskHistoryList }